import { HTTP } from "@/utils/http-common"
import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"

export default {
  async getMessage(companyId, projectID) {
    const path = `/projects/ia/company/${companyId}/project/${projectID}`
    const response = await HTTP.get(path)
    return response.data
  },

  async startChat(companyId, projectId) {
    return HTTP.post(`/projects/ia/company/${companyId}/project/${projectId}/start-chat`).then(
      res => res.data
    )
  },

  async sendMessage($, companyId, projectId, message) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/projects/ia/company/${companyId}/project/${projectId}/chat`, message)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },

  async generateReport(companyId, projectId, selectedQuestions) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/projects/ia/company/${companyId}/project/${projectId}/report`, {
        company_id: companyId,
        project_id: projectId,
        add_qst: selectedQuestions
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  }
}
